/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export function dateToValidation(dateStartForm: FormGroup, dateEndForm: FormGroup): ValidatorFn {
  return (control: AbstractControl): { msg: string } | null => {
    if (!dateStartForm.value.date || !dateEndForm.value.date) {
      return null;
    }

    const startDate = getFormDateObject(dateStartForm, '00:00');
    const endDate = getFormDateObject(dateEndForm, '23:59');

    const isValid = endDate.getTime() > startDate.getTime();

    return isValid ? null : { msg: '' };
  };
}

export function timeValidation(control: AbstractControl): { msg: string } | null {
  const isValid = control.value;

  return isValid ? null : { msg: 'Wprowadź godzinę' };
}

function getFormDateObject(form: FormGroup, defaultTime: string) {
  const date = form.controls.date.value;
  const time = form.controls.time.value || defaultTime;

  return new Date(date + ' ' + time);
}

export function getToday () {
  const today = new Date();
  const todayIso = new Date(today.getTime()).toISOString().split('T')[0];
  return todayIso;
}
